export enum CommunicationLogParticipantType {
  externalPhone = 'externalPhone',
  userId = 'userId',
  serviceableAddressId = 'serviceableAddressId',
}

export type CommunicationLogParticipantTypeType = keyof typeof CommunicationLogParticipantType;
